import * as React from 'react';
import ApiServerRequest from 'models/ApiServerRequest';
import DownloadContext from 'contexts/DownloadContext';
import './EditableDateCell.css';
import RenderingContext from 'contexts/RenderingContext';
import Popup from 'components/custom-table/action/Popup';
import { sendFetchError } from 'utils/messageUtils';
import TrancheWrapper from '../../../../models/TrancheWrapper';
import EditableCell from './EditableCell';
const EditablePopUp = ({ cell, column, row, table, }) => {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const { printAny } = React.useContext(RenderingContext);
    const popupRef = React.useRef(null);
    const editableCellRef = React.useRef(null);
    const [errorText, setErrorText] = React.useState();
    const [isDisabled, setDisabled] = React.useState(false);
    const [isEditing, setEditing] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false);
    const text = React.useMemo(() => {
        const newValue = column.accessorFn !== undefined ? column.accessorFn(row.original, row.index) : undefined;
        return printAny(newValue);
    }, [column, printAny, row.index, row.original]);
    const save = React.useCallback(async (valueToSave) => {
        if (table.options.meta !== undefined && typeof table.options.meta.updateTable === 'function') {
            const isPresent = valueToSave !== undefined;
            const formData = new FormData();
            formData.append('transactionId', row.original.transaction.id);
            formData.append('trancheIndex', row.original.trancheIndex.toString());
            if (isPresent) {
                const value = typeof valueToSave === 'string' ? valueToSave : new Blob([JSON.stringify(valueToSave)], { type: 'application/json' });
                formData.append('value', value);
            }
            ;
            const editableTranches = table.getRowModel().rows.filter((r) => r.original.transaction.id === row.original.transaction.id).map((r) => r.original.setEditable(true));
            table.options.meta.updateTable(editableTranches);
            setDisabled(true);
            setLoading(true);
            const method = isPresent ? 'PATCH' : 'DELETE';
            const request = new ApiServerRequest('/syndicate/override/' + column.id, { body: formData, method });
            try {
                const body = await apiFetchJson(request);
                const tranches = body.map((t) => new TrancheWrapper(t));
                table.options.meta.updateTable(tranches);
            }
            catch (error) {
                sendFetchError('Unable to save data', error, request);
                setErrorText(`Error overriding: ${JSON.stringify(error)}`);
            }
            finally {
                setDisabled(false);
                setEditing(false);
                setLoading(false);
                editableCellRef.current?.focus();
            }
        }
    }, [apiFetchJson, column.id, row.original.trancheIndex, row.original.transaction.id, table]);
    const removeOverride = React.useCallback(() => {
        (async () => save(undefined))();
    }, [save]);
    const closePopup = React.useCallback(() => {
        setEditing(false);
    }, []);
    const title = React.useMemo(() => {
        if (column.accessorFn !== undefined) {
            const copy = row.original.removeOverrideMap().removeOverride();
            const newValue = column.accessorFn(copy, row.index);
            return printAny(newValue);
        }
    }, [column, printAny, row.index, row.original]);
    const value = React.useMemo(() => {
        return column.accessorFn !== undefined ? column.accessorFn(row.original, row.index) : undefined;
    }, [column, row.index, row.original]);
    const hasOverride = React.useMemo(() => {
        if (column.accessorFn !== undefined) {
            const copy = row.original.removeData();
            const newValue = column.accessorFn(copy, row.index);
            return newValue !== undefined;
        }
        return false;
    }, [column, row.index, row.original]);
    const content = React.useMemo(() => {
        if (isEditing && column.columnDef.meta?.Editor) {
            return (React.createElement("div", { className: "co-editable-date" },
                React.createElement(Popup, { close: closePopup, ref: popupRef, style: { padding: '0.5rem', transform: 'translate(0.25rem, -0.75rem)' } },
                    React.createElement(column.columnDef.meta.Editor, { data: row.original, hasOverride: hasOverride, hasValue: title !== undefined, initialValue: value, isDisabled: isDisabled, save: save }))));
        }
        return text;
    }, [closePopup, column, hasOverride, isDisabled, isEditing, row.original, save, text, title, value]);
    return (React.createElement(EditableCell, { errorText: errorText, isEditing: isEditing, isLoading: isLoading, isLoadingRow: row.original.isEditing, isOverriden: hasOverride, key: cell.id, ref: editableCellRef, removeOverride: removeOverride, setEditing: setEditing, title: title }, content));
};
export default EditablePopUp;
